module.exports = __webpack_public_path__ + "static/media/qrcode.ea2f2215.jpg";